/* Quick add for .msc-card buttons ([data-msc-add="<variant id>"]).
   Adds to the bag, refreshes Dawn's cart drawer when present, otherwise goes
   to /cart. Fires `msc:cart-updated` ({ detail: { itemCount } }) for the header. */
(function () {
  if (window.__mscCard) return;
  window.__mscCard = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-msc-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = Number(btn.getAttribute('data-msc-add'));
    var drawer = document.querySelector('cart-drawer');
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    var body = { items: [{ id: id, quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        if (!res.ok) { window.location.href = root + 'cart'; return; }
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
        fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('msc:cart-updated', { detail: { itemCount: cart.item_count } }));
        }).catch(function () {});
        if (drawer && drawer.renderContents && res.json.sections) {
          var state = res.json; state.id = id;
          drawer.classList.remove('is-empty');
          drawer.renderContents(state);
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function () { window.location.href = root + 'cart'; });
  });
})();
